import React, { Component } from "react";
import PropTypes from 'prop-types';
import { WHITE } from "../../styles/shared/colors";
import SingleInput from './SingleInput';
import "./GameScoreInputs.scss";

const H = "H";
const A = "A";

class GameScoreInputs extends Component {
  static propTypes = {
    updateAwayScore: PropTypes.func,
    updateHomeScore: PropTypes.func
  };

  static defaultProps = {
    updateAwayScore: ()=> {},
    updateHomeScore: ()=> {}
  };

  state = {
    home: null,
    away: null,
    isHomeOnFocus: false,
    isAwayOnFocus: false
  };

  static getDerivedStateFromProps(props, state) {
    const { score: { home, away } } = props;
    if ((home !== null || away !== null) && (!state.home && !state.away )) {
      return {
        home, away
      };
    };
    return {};
  }


  updateValue = (value, currentInput) => {
    if (currentInput === H) {
      this.setState({
        home: value
      });
      return;
    }
    this.setState({
      away: value
    });
  };

  handleFocus = currentInput => {
    if (currentInput === H) {
      this.setState({
        isHomeOnFocus: true
      });
      return;
    }
    this.setState({
      isAwayOnFocus: true
    });
  };

  handleBlur = (currentInput, value) => {
    const { updateHomeScore, updateAwayScore } = this.props;
    if (currentInput === H) {
      this.setState({
        isHomeOnFocus: false
      });
      updateHomeScore(value || null);
      return;
    }
    updateAwayScore(value || null);
    this.setState({
      isAwayOnFocus: false
    });
  };

  /* eslint-disable react/jsx-handler-names */

  render() {
    const { away, home, isHomeOnFocus, isAwayOnFocus } = this.state;
    const { isEditable } = this.props;

    return (
      <div className="game-score-inputs">
        <SingleInput
          scoreType={H}
          score={home}
          isOnFocus={isHomeOnFocus}
          handleFocus={this.handleFocus}
          handleBlur={this.handleBlur}
          updateValue={this.updateValue}
          isEditable={isEditable}
        />
        <div
          style={{
            height: "100%",
            margin: "2px 5px",
            borderLeft: `2px solid ${home || away ? WHITE : "#7d7c7d"}`
          }}
        />
        <SingleInput
          scoreType={A}
          score={away}
          isOnFocus={isAwayOnFocus}
          handleFocus={this.handleFocus}
          handleBlur={this.handleBlur}
          updateValue={this.updateValue}
          isEditable={isEditable}
        />
      </div>
    );
  }
}

/* eslint-enable react/jsx-handler-names */

export default GameScoreInputs;
